const selector = '[data-tg-review-sync-url]';
const cache = new Map();
const pending = new Map();
const observed = new WeakSet();

const renderSummary = (card, summary) => {
  const review = card.querySelector('.tg-card-proof__reviews');
  if (!review) return;
  const count = Number(summary.count) || 0;
  const ratedCount = Number(summary.ratedCount) || 0;
  const average = Number(summary.average) || 0;
  if (count < 1 || ratedCount < 1) {
    review.className = 'tg-card-proof__reviews tg-card-proof__reviews--empty';
    review.hidden = true;
    review.style.display = 'none';
    review.innerHTML = '';
    return;
  }
  const rounded = Math.round(average);
  const stars = '★'.repeat(rounded) + '☆'.repeat(5 - rounded);
  review.className = 'tg-card-proof__reviews';
  review.hidden = false;
  review.style.display = '';
  review.setAttribute('aria-label', `5点中${average.toFixed(1)}点、${count}件のレビュー`);
  review.innerHTML = `<span class="tg-card-proof__stars" aria-hidden="true">${stars}</span><strong>${average.toFixed(1)}</strong><span>レビュー ${count}件</span>`;
};

const parseSection = (markup) => {
  const documentFragment = new DOMParser().parseFromString(markup || '', 'text/html');
  const section = documentFragment.querySelector('[data-tg-gpu-review-section]');
  if (!section) return null;
  return {
    count: section.dataset.reviewCount,
    ratedCount: section.dataset.ratedCount,
    average: section.dataset.ratingAverage
  };
};

const fetchSummary = async (url) => {
  const response = await fetch(new URL(url, window.location.origin), { credentials: 'same-origin' });
  if (!response.ok) throw new Error(`Review page request failed: ${response.status}`);
  return parseSection(await response.text());
};

const syncCard = async (card) => {
  const url = card.dataset.tgReviewSyncUrl;
  const key = card.dataset.tgReviewSyncKey;
  if (!url || !key) return;
  const path = new URL(url, window.location.origin).pathname;
  if (cache.has(key)) {
    renderSummary(card, cache.get(key));
    return;
  }
  if (!pending.has(key)) {
    const request = fetchSummary(path)
      .then((summary) => {
        if (!summary) return null;
        cache.set(key, summary);
        document.querySelectorAll(selector).forEach((candidate) => {
          if (candidate.dataset.tgReviewSyncKey === key) renderSummary(candidate, summary);
        });
        return summary;
      })
      .catch(() => null)
      .finally(() => pending.delete(key));
    pending.set(key, request);
  }
  await pending.get(key);
};

const observer = 'IntersectionObserver' in window
  ? new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        syncCard(entry.target);
      });
    }, { rootMargin: '300px 0px' })
  : null;

const observeCards = () => {
  document.querySelectorAll(selector).forEach((card) => {
    if (observed.has(card)) return;
    observed.add(card);
    if (observer) observer.observe(card);
    else syncCard(card);
  });
};

observeCards();
const mutationObserver = new MutationObserver(observeCards);
mutationObserver.observe(document.documentElement, { childList: true, subtree: true });
